// plan-08 S02: descent animation — 2.4 s overlay + tunnel + materialization
// bible §26, §15

let overlay: HTMLElement | null = null
let tunnelCanvas: HTMLCanvasElement | null = null

export function runDescent(reduced: boolean, onComplete: () => void): void {
  // overlay
  overlay = document.createElement('div')
  overlay.className = 'vt-portal-overlay'
  document.body.appendChild(overlay)

  // force reflow then fade in
  void overlay.offsetWidth

  if (reduced) {
    // reduced motion: 400 ms fade only, no tunnel
    overlay.style.opacity = '1'
    setTimeout(onComplete, 400)
    return
  }

  // phase 1: overlay fade (0–400 ms)
  overlay.style.opacity = '1'

  // phase 2: tunnel (400–1400 ms)
  setTimeout(() => {
    tunnelCanvas = document.createElement('canvas')
    tunnelCanvas.className = 'vt-portal-tunnel'
    tunnelCanvas.width = window.innerWidth
    tunnelCanvas.height = window.innerHeight
    document.body.appendChild(tunnelCanvas)
    animateTunnel(tunnelCanvas, 1000)
  }, 400)

  // phase 3: materialization (1400–2400 ms)
  setTimeout(() => {
    if (tunnelCanvas) {
      tunnelCanvas.style.opacity = '0'
    }
    onComplete()
  }, 1400)
}

export function removeDescent(reduced: boolean, onDone: () => void): void {
  const duration = reduced ? 200 : 600

  if (overlay) {
    overlay.style.opacity = '0'
  }

  setTimeout(() => {
    if (tunnelCanvas) {
      tunnelCanvas.remove()
      tunnelCanvas = null
    }
    if (overlay) {
      overlay.remove()
      overlay = null
    }
    onDone()
  }, duration)
}

function animateTunnel(canvas: HTMLCanvasElement, durationMs: number): void {
  const raw = canvas.getContext('2d')
  if (!raw) return
  const ctx = raw

  const w = canvas.width
  const h = canvas.height
  const cx = w / 2
  const cy = h / 2
  const rects = 8
  const start = performance.now()

  function draw(now: number): void {
    const elapsed = now - start
    const t = Math.min(elapsed / durationMs, 1)

    ctx.clearRect(0, 0, w, h)

    for (let i = 0; i < rects; i++) {
      const depth = i / rects
      const scale = 0.15 + depth * 0.85 * t
      const rot = (depth * 0.08 * t) + (t * 0.02 * i)
      const rw = w * scale * 0.8
      const rh = h * scale * 0.8
      const alpha = 0.08 + depth * 0.12

      ctx.save()
      ctx.translate(cx, cy)
      ctx.rotate(rot)
      ctx.strokeStyle = `rgba(0, 90, 0, ${alpha})`
      ctx.lineWidth = 1

      if (i === rects - 1) {
        // innermost: accumulates green glow
        const glowAlpha = 0.1 + t * 0.3
        ctx.strokeStyle = `rgba(0, 210, 0, ${glowAlpha})`
        ctx.shadowColor = 'rgba(0, 180, 0, 0.3)'
        ctx.shadowBlur = 12 * t
      }

      ctx.strokeRect(-rw / 2, -rh / 2, rw, rh)
      ctx.restore()
    }

    if (t < 1) {
      requestAnimationFrame(draw)
    }
  }

  requestAnimationFrame(draw)
}
